import { render } from "./LoginHandler.vue?vue&type=template&id=b0807b4c&scoped=true"
import script from "./LoginHandler.vue?vue&type=script&lang=js"
export * from "./LoginHandler.vue?vue&type=script&lang=js"

import "./LoginHandler.vue?vue&type=style&index=0&id=b0807b4c&scoped=true&lang=css"

import exportComponent from "/home/rich/web/spelling-bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0807b4c"]])

export default __exports__